import React from 'react';

// CSS-only starfield background
export default function StarField() {
  return (
    <div 
      style={{ 
        position: 'fixed', 
        top: 0, 
        left: 0, 
        width: '100%', 
        height: '100%', 
        zIndex: 0,
        pointerEvents: 'none',
        overflow: 'hidden'
      }}
    >
      {/* Static star dots */}
      {[...Array(100)].map((_, i) => {
        const size = Math.random() * 2 + 1;
        const x = Math.random() * 100;
        const y = Math.random() * 100;
        const delay = Math.random() * 5;
        const duration = Math.random() * 3 + 2;
        
        return (
          <div
            key={i}
            className="absolute rounded-full animate-pulse"
            style={{
              width: `${size}px`,
              height: `${size}px`,
              left: `${x}%`,
              top: `${y}%`,
              backgroundColor: '#ffffff',
              opacity: Math.random() * 0.4 + 0.2,
              animationDelay: `${delay}s`,
              animationDuration: `${duration}s`
            }}
          />
        );
      })}
      
      {/* Cyan floating particles */}
      {[...Array(20)].map((_, i) => {
        const size = Math.random() * 3 + 1;
        const x = Math.random() * 100;
        const duration = Math.random() * 20 + 15;
        const delay = Math.random() * 10;
        
        return (
          <div
            key={`cyan-${i}`}
            className="absolute rounded-full"
            style={{
              width: `${size}px`,
              height: `${size}px`,
              left: `${x}%`,
              bottom: '-10px',
              backgroundColor: '#00F0FF',
              opacity: 0.4,
              boxShadow: '0 0 10px rgba(0, 240, 255, 0.5)',
              animation: `floatUp ${duration}s linear ${delay}s infinite`
            }}
          />
        );
      })}
      
      <style>{`
        @keyframes floatUp {
          0% {
            transform: translateY(0);
            opacity: 0;
          }
          10% {
            opacity: 0.4;
          }
          90% {
            opacity: 0.2;
          }
          100% {
            transform: translateY(-110vh);
            opacity: 0;
          }
        }
      `}</style>
    </div>
  );
}
